import React from 'react'
import PropTypes from 'prop-types'

import ClientLocationItem from "./ClientLocationItem";

const ClientLocationsList = ({client_id, addresses}) => {
    return (
        <div className="d-flex flex-column">
            {addresses && addresses.map(({address_id, full_address}) => <ClientLocationItem
                key={address_id}
                client_id={client_id}
                address_id={address_id}
                address={full_address}/>)}
        </div>
    )
}

ClientLocationsList.propTypes = {
    client_id: PropTypes.number.isRequired,
    addresses: PropTypes.array
}

export default ClientLocationsList